import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Cookies from 'js-cookie';
import logo1 from '../assets/logo1.webp';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';

const options = [
  { value: 'en', label: 'English' },
  { value: 'mr', label: 'मराठी' },
];

const LanguageSelector = ({ closeNavbar }) => {
  const { i18n } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(options[0]); // Default to English

  useEffect(() => {
    const savedLanguage = Cookies.get('language') || 'en';
    const currentOption = options.find(option => option.value === savedLanguage);
    if (currentOption && currentOption.value !== selectedOption.value) {
      setSelectedOption(currentOption);
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n, selectedOption]);

  const handleLanguageChange = (option) => {
    setSelectedOption(option);
    i18n.changeLanguage(option.value);
    Cookies.set('language', option.value);
    closeNavbar(); // Automatically close the Navbar
  };

  return (
    <div style={{ margin: '20px' }}>
      <Select
        options={options}
        value={selectedOption}
        onChange={handleLanguageChange}
        isSearchable
        placeholder=""
        styles={{
          option: (provided) => ({
            ...provided,
            color: 'black',
          }),
        }}
        aria-label="Language Selector"
      />
    </div>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-lg">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8 xl:px-10 2xl:px-12">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="home" smooth={true} duration={500}>
              <img
                src={logo1}
                alt="Logo"
                className="cursor-pointer w-16 h-16 sm:w-20 sm:h-20"
              />
            </Link>
          </div>
          <div className="items-center hidden space-x-4 lg:flex 2xl:space-x-6">
            <button
              onClick={() => scrollToElement('home')}
              className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Home')}
            </button>
            <button
              onClick={() => scrollToElement('scholarship-0')}
              className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Shani Mandir')}
            </button>
            <button
              onClick={() => scrollToElement('scholarship-1')}
              className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Scholarship')}
            </button>
            <button
              onClick={() => scrollToElement('scholarship-2')}
              className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Social Security')}
            </button>
            {/* <button
              onClick={() => scrollToElement('')}
              className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Download')}
            </button> */}
            {/* <div className="relative group">
              <button className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]">
                {t('Download')}
              </button>
              <div className="absolute right-0 w-48 mt-2 bg-white border border-gray-200 rounded-md shadow-lg opacity-0 group-hover:opacity-100 group-hover:block hidden">
                <a href="" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" >
                  {t('Annual')}
                </a>
              </div>
            </div> */}
            {/* <button className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]">
              {t('photo')}
            </button> */}
            <button onClick={() => scrollToElement('footer')} className="text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]">
              {t('Contact Us')}
            </button>
          </div>

          <div className="items-center hidden space-x-4 lg:flex 2xl:space-x-6">
            <a
              href="https://forms.gle/CSu8q4VhwmrWebfa7"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              {t('Donation')}
            </a>
            <LanguageSelector className='text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"' closeNavbar={() => setIsOpen(false)} />
          </div>
          <div className="flex -mr-2 lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]"
            >
              <svg className="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className={`${isOpen ? 'block sticky top-0 z-50' : 'hidden'} lg:hidden`}>
        <div className="flex flex-col items-center px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <button onClick={() => scrollToElement('home')} className="inline-block px-4 py-2 text-gray-800 font-semibold hover:text-gray-900 text-[16px]  2xl:text-[16px]">{t('Home')}</button>
          <button onClick={() => scrollToElement('scholarship-0')} className="inline-block px-4 py-2 text-gray-800 font-semibold hover:text-gray-900 text-[16px]  2xl:text-[16px]">{t('Shani Mandir')}</button>
          <button onClick={() => scrollToElement('scholarship-1')} className="inline-block px-4 py-2 text-gray-800 font-semibold hover:text-gray-900 text-[16px]  2xl:text-[16px]">{t('Scholarship')}</button>
          <button onClick={() => scrollToElement('scholarship-2')} className="inline-block px-4 py-2 text-gray-800 font-semibold hover:text-gray-900 text-[16px]  2xl:text-[16px]">{t('Social Security')}</button>
          {/* <div className="re text-gray-900 font-bold
            <button className="inline-block px-4 py-2 text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]">
              {t('Download')}
            </button>
            <div className="absolute right-0 w-48 mt-2 bg-white border border-gray-200 rounded-md shadow-lg opacity-0 group-hover:opacity-100 group-hover:block hidden">
              <a href="" className="inline-block px-4 py-2 text-gray-700 hover:text-gray-900 text-[10px] sm:text-[12px] lg:text-[14px] xl:text-[15px] 2xl:text-[16px]" download>
                {t('Annual')}
              </a>
            </div>
          </div> */}
          <button onClick={() => scrollToElement('footer')} className="inline-block w-full px-4 py-2 text-gray-800 font-semibold text-center hover:text-gray-900 text-[16px]  2xl:text-[16px]">{t('Contact Us')}</button>
          <a href="https://forms.gle/CSu8q4VhwmrWebfa7" target="_blank" rel="noopener noreferrer" className="inline-block  px-4 py-2 text-center text-white bg-red-600 rounded-md hover:bg-red-700 text-[16px]  2xl:text-[16px]">
            {t('Donation')}
          </a>
          <LanguageSelector closeNavbar={() => setIsOpen(false)} />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
